const CheckIcon = () => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99998 7.77999L1.21998 4.99999L0.273315 5.93999L3.99998 9.66665L12 1.66665L11.06 0.726654L3.99998 7.77999Z"
        fill="#0CF607"
      />
    </svg>
  );
};

export default CheckIcon;
